import { render, staticRenderFns } from "./WipTicketTable.vue?vue&type=template&id=234572e6&scoped=true&"
import script from "./WipTicketTable.vue?vue&type=script&lang=ts&"
export * from "./WipTicketTable.vue?vue&type=script&lang=ts&"
import style0 from "./WipTicketTable.vue?vue&type=style&index=0&id=234572e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234572e6",
  null
  
)

export default component.exports